import React, { Fragment, useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";

import { language } from "../../../../../language";
import GenericModal from "../../../../modal-closebtn/index";
import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import IconButton from "@mui/material/IconButton";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import BarcodeCode128Svg from '../../../../../assets/icons/qrbarcode/BarcodeCode128Svg';
import BarcodeEan13Svg from "../../../../../assets/icons/qrbarcode/BarcodeEan13Svg";
import BarcodeEan8Svg from "../../../../../assets/icons/qrbarcode/BarcodeEan8Svg";
import BarcodeItf14Svg from "../../../../../assets/icons/qrbarcode/BarcodeItf14Svg";
import BarcodeUpcASvg from "../../../../../assets/icons/qrbarcode/BarcodeUpcASvg";
import BarcodeUpcESvg from "../../../../../assets/icons/qrbarcode/BarcodeUpcESvg";
import QrCodeModel1_2Svg from "../../../../../assets/icons/qrbarcode/QrCodeModel1_2Svg";
import QrCodeMicroSvg from "../../../../../assets/icons/qrbarcode/QrCodeMicroSvg";
import BarcodeCode93Svg from "../../../../../assets/icons/qrbarcode/BarcodeCode93Svg";
import { styled } from "@mui/material/styles";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

const Title = styled(InputLabel)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.main,
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const TextFieldStyled = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: '#164194', // label em foco flutuando
  },
  '& label.MuiInputLabel-shrink': {
    color: '#164194', // label sem foco flutuando
  },
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: '#164194',   // borda
    },
    '&.Mui-focused fieldset': {
      borderColor: '#164194',  // borda
    },
  },
}));

const CODE_TYPES = [ 
  {
    value: "QR_CODE",
    label: "QR",
  }, 
  {
    value: "BAR_CODE",
    label: "Barra"
  }
];

const QR_CODE_MODELS = [
  {
    value: "QR_MODEL_1_2",
    label: "Model 1 & 2 (Padrão)",
    svg: QrCodeModel1_2Svg,
  },
	{
    value: "QR_MICRO",
    label: "Micro",
    svg: QrCodeMicroSvg,
  },
];

const BAR_CODE_MODELS = [ 
  
	{
    value: "BAR_EAN_13",
    label: "EAN 13",
    svg: BarcodeEan13Svg,
  },
	{
    value: "BAR_EAN_8",
    label: "EAN 8",
    svg: BarcodeEan8Svg,
  },
	{
    value: "BAR_CODE_128",
    label: "GSI-128",
    svg: BarcodeCode128Svg
  },
  {
    value: "BAR_CODE_93",
    label: "CODE 93",
    svg: BarcodeCode93Svg,
  },
  {
    value: "BAR_ITF_14",
    label: "ITF-14",
    svg: BarcodeItf14Svg,
  },
	{
    value: "BAR_UPC_A",
    label: "UPC A",
    svg: BarcodeUpcASvg,
  },
	{
    value: "BAR_UPC_E",
    label: "UPC E",
    svg: BarcodeUpcESvg,
  },
];

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,

  addCodigo,
  
  handleChangeListValue,
  removeListItem,
  handleChangeAutoCompleteListValue,
  handleClearAutoCompletePropValue,

  handleChangeConfigFields,
  handleChangeAutoCompleteConfigFields,

  taskFields,
  businessObject,
}) {

  const items = jsonConfig?.items || [];

  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(getUniqueDocumentServiceFields(businessObject));

  documentVariables = documentVariables.filter((value, index, self) => {
    return index === self.findIndex((obj) => obj.id === value.id);
  }).map(value => value.id);

  const formFieldsVariables = 
    taskFields?.filter((taskField) => !documentVariables.some(docItem => docItem === taskField.id)) || [];

  // lista de modelo para cada item da lista
  let codeModelList = items.map((item) => {
    let models = [];

    if(item?.codeType === "QR_CODE"){
      models = QR_CODE_MODELS;
    } else if(item?.codeType === "BAR_CODE"){
      models = BAR_CODE_MODELS;
    } 
    
    return models;
  });

  return (
    <>
      <Grid item size={12} style={{ height: '29px', marginBottom: '40px', marginTop: '20px'}}>
        <Typography variant="h6" style={{fontWeight: 'bold'}} >{language.codeToGenerate}</Typography>
      </Grid>

      <Grid item size={12} container spacing={3} style={{ marginBottom: '30px'}} wrap="wrap" >
        {items && items.length > 0 ? 
          <>
            {
              items.map((itemCode, index) => {

                return <Fragment key={`item_${index}codeType`}>

                  <Grid item  size={{xs: 12, sm: 6, md: 4}} justifyContent="flex-start" alignItems="center" style={{ display: 'flex'}}>
                    <Typography variant="body1" aria-required style={{fontWeight: 'bold'}}>{language.codeType}*</Typography>
                  </Grid>
                  <Grid item size={{xs: 12, sm: 6, md: 3}} justifyContent="flex-start" alignItems="center" style={{ display: 'flex'}}>
                    <Typography variant="body1" style={{fontWeight: 'bold'}}>{language.model}*</Typography>
                  </Grid>
                  <Grid item size={{xs: 12, sm: 6, md: 4}} justifyContent="flex-start" alignItems="center" style={{ display: 'flex'}}>
                    <Typography variant="body1" style={{fontWeight: 'bold'}}>{language.idVariable}*</Typography>
                  </Grid>
                  <Grid item  size={{xs: 12, sm: 6, md: 1}} justifyContent="flex-end" alignItems="center" style={{ display: 'flex'}}>
                    <Typography variant="body1" style={{fontWeight: 'bold', textAlign: 'right'}}>{language.addRemove}</Typography>
                  </Grid>

                  <Grid item size={{xs: 12, sm: 6, md: 4}} style={{ marginRight: 0}} >
                    <Autocomplete
                      value={CODE_TYPES.find(item => item.value === items[index]?.codeType)?.label || ""}
                      onChange={(event, value) => {
                        const previousValue = items[index]?.codeType;
                        handleChangeAutoCompleteListValue(event, value, index, "codeType", "items", "value")

                        if(value?.value !== previousValue){
                          handleClearAutoCompletePropValue(index, "modelo", "items", "");
                        }
                      }}
                      onInputChange={(event) => handleChangeListValue(event, index, "codeType", "items")}
                      selectOnFocus
                      id={`s${index}_codeType"`}
                      name="codeType"
                      disableClearable
                      options={CODE_TYPES}
                      getOptionLabel={(model) => { 
                        if(typeof model === 'string'){
                          return model;
                        } 
                        return model?.label || "";
                      }}
                      renderOption={(props, option) => {
                        return  <li {...props}>
                          <Typography variant="body1" >{option?.label || ""}</Typography>
                        </li>
                      }}
                      renderInput={(params) => (
                        <TextFieldStyled
                          {...params}
                          variant="outlined"
                          name="codeType"
                          required
                          label={language.codeType}
                          inputProps={{ 
                            ...params.inputProps, 
                            readOnly: true, 
                          }}
                          sx={{
                            cursor: 'pointer',
                            '& .MuiInputBase-root': {
                              cursor: 'pointer',
                            },
                            '& .MuiInputBase-input': {
                              cursor: 'pointer',
                            },
                            input: {
                              color: "#164194",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item size={{xs: 12, sm: 6, md: 3}} style={{ marginRight: 0}} >
                      <Autocomplete
                        value={codeModelList[index].find(item => item.value === items[index]?.modelo)?.label || ""}
                        onChange={(event, value) => handleChangeAutoCompleteListValue(event, value, index, "modelo", "items", "value")}
                        onInputChange={(event) => handleChangeListValue(event, index, "modelo", "items")}
                        selectOnFocus
                        id={`s${index}_modelo"`}
                        name="modelo"
                        disableClearable
                        options={codeModelList[index]}
                        getOptionLabel={(model) => { 
                          if(typeof model === 'string'){
                            return model;
                          } 
                          return model?.label || "";
                        }}
                        renderOption={(props, option) => {
                          return  <li {...props}>
                            <Typography variant="body1" >{option?.label || ""}</Typography>
                          </li>
                        }}
                        renderInput={(params) => (
                          <TextFieldStyled
                            {...params}
                            variant="outlined"
                            name="resultId"
                            required
                            label={language.model}
                            inputProps={{ 
                              ...params.inputProps, 
                              readOnly: true, 
                            }}
                            sx={{
                              cursor: 'pointer',
                              '& .MuiInputBase-root': {
                                cursor: 'pointer',
                              },
                              '& .MuiInputBase-input': {
                                cursor: 'pointer',
                              },
                              input: {
                                color: "#164194",
                              },
                            }}
                          />
                        )}
                      />
                  </Grid>

                  <Grid item size={{xs: 12, sm: 6, md: 4}}>
                    <Autocomplete
                      value={items[index]?.resultId || ""}
                      onChange={(event, value) => handleChangeAutoCompleteListValue(event, value, index, "resultId", "items")}
                      onInputChange={(event) => handleChangeListValue(event, index, "resultId", "items")}
                      selectOnFocus
                      freeSolo
                      id={`s${index}_resultId"`}
                      name="resultId"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => { 
                        if(typeof formField === 'string'){
                          return formField;
                        } 
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextFieldStyled
                          {...params}
                          variant="outlined"
                          name="resultId"
                          required
                          label={language.idVariable}
                          sx={{
                            input: {
                              color: "rgba(0, 0, 0, 0.6)",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  
                  <Grid item size={{ xs: 12, sm: 6, md: 1}} justifyContent="end" alignItems="center" style={{ display: 'flex'}}>
                    {items.length == 1 && !items[0]?.modelo
                      ? (
                         // mostra o botão adicionar ao inves do "remover" se tiver apenas 1 item na lista
                        <IconButtonStyled
                          size="small"
                          color="primary"
                          onClick={addCodigo}
                        >
                          <AddIcon />
                        </IconButtonStyled>
                      )
                      : (
                        <IconButton
                          size="small"
                          color="primary"
                          style={{
                            borderRadius: '8px',
                            border: '1px solid'
                          }}
                          onClick={(event) => {
                            removeListItem(event, index, "items");
                            if(items.length == 0){
                              // não deixa a lista ficar sem items 
                              // (só para garantir que o comportamento do botão adicionar continue aparecendo no primeiro item da lista)
                              addCodigo();
                            }
                          }}
                        >
                          <RemoveIcon />
                        </IconButton>
                      )
                    }
                  </Grid>

                  {itemCode?.modelo &&
                    <>
                      <Grid item  size={{ xs: 12, sm: 6, md: 4}} >
                        <Stack direction="column" justifyContent="center" alignItems="center">
                          <Typography variant="body1" sx={{ textTransform: 'uppercase' }} >{language.model}</Typography>
                          <Box sx={{ height: "130px", marginTop: "20px" }}>
                            {(() => {
                              // retornando Svg com base no modelo selecionado
                              const selectedModelo = codeModelList[index].find(model => model.value === itemCode?.modelo);
                              const SvgComponent = selectedModelo?.svg;

                              return SvgComponent && <SvgComponent /> || <></>
                            })()}
                          </Box>
                          <Typography variant="body1">
                            {(() => {
                              // retornando label com base no modelo selecionado
                              const selectedModelo = codeModelList[index].find(model => model.value === itemCode?.modelo);
                              return selectedModelo?.label;
                            })()}
                          </Typography>
                        </Stack>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 6, md: 8 }} >
                      <Autocomplete
                        value={items[index]?.content || ""}
                        onChange={(event, value) => handleChangeAutoCompleteListValue(event, value, index, "content", "items")}
                        onInputChange={(event) => handleChangeListValue(event, index, "content", "items")}
                        selectOnFocus
                        freeSolo
                        id={`s${index}_content"`}
                        name="content"
                        options={formFieldsVariables}
                        getOptionLabel={(formField) => { 
                          if(typeof formField === 'string'){
                            return formField;
                          } 
                          return formField?.id || "";
                        }}
                        renderInput={(params) => (
                          <TextFieldStyled
                            {...params}
                            variant="outlined"
                            name="content"
                            required
                            label={language.codeContent}
                            minRows={7}
                            multiline
                            sx={{
                              '& textarea': {
                                color: "rgba(0, 0, 0, 0.6)",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </>
                }

                {items.length > 1 && <Divider style={{width: "100%", height: 1, marginBottom: '24px', marginTop: '24px'}} />}

                </Fragment>

              })
            }
          </>
          : <Grid item size={12} justifyContent="center" alignItems="center" style={{ display: 'flex'}} >
              <Typography variant="body1" style={{fontWeight: '400'}}>{language.noCodeSelected}</Typography>
           </Grid>
        }
        <Grid item size={11}></Grid>
        {!(items.length == 1 && !items[0]?.modelo) &&
           // negação da regra do botão adicionar
          <Grid item size={1} justifyContent="end" alignItems="center" style={{ display: 'flex'}}>
            <IconButtonStyled
                size="small"
                color="primary"
                onClick={addCodigo}
              >
                <AddIcon />
              </IconButtonStyled>
          </Grid>
        }
      </Grid>

    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerGerarQrBarCode({
  saveGerarQrBarCodeConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
}){
  const [jsonConfig, setJsonConfig] = useState({
    items: [],
  })
  
  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "xl",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {

    if(inputValues){

      let items = [];

      if(inputValues?.items){
        items = inputValues.items.map((item, index) => {
          return {
            codeType: item?.codeType,
            modelo: item?.modelo,
            resultId: item?.resultId,
            content: item?.content,
          }
        });
      }

      if(items.length == 0){
        // inicia o compontente com 1 item com dados em branco
        items.push({
          codeType: "",
          modelo: "",
          resultId: "",
          content: "",
        });
      }

      setJsonConfig({
        items: items,
      });
    } else{

      // inicia o compontente com 1 item com dados em branco
      setJsonConfig({
        items: [
          {
            codeType: "",
            modelo: "",
            resultId: "",
            content: "",
          }
        ],
      });
    }

  }, [inputValues]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev, 
      tabValue: newValue
    }));
  };

  const validateConfig = (obj) => {
    let erros = [];

    if(!obj.items || obj.items.length <= 0){
      erros.push("Código é obrigatório");
    }

    if(obj.items?.length){
      if(obj.items.filter(item => !item.codeType || !item.modelo || !item.resultId || !item.content).length > 0){
        erros.push("Preencha todos os dados do código");
      }
    }

    return erros;
  }

  const handleSave = () => {

    let items = jsonConfig?.items || [];

    items = items.map((field, index) => {
      return {
        codeType: field?.codeType,
        modelo: field?.modelo,
        resultId: field?.resultId,
        content: field?.content,
      }
    });

    const inputObject = {
      items: items,
    }

    const erros = validateConfig(inputObject)

    if(erros.length > 0){
      setHasConfigError(erros);
    } else{

      //salvando no modeler
      saveGerarQrBarCodeConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  }

  const handleChangeConfigFields = (event) => {
    if(!event?.target) return;

    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeAutoCompleteConfigFields = (event, value, name, attributeField) => {
    if(!event?.target) return;

    let newValue;
    if(typeof value === 'string'){
      newValue = value;
    } else if(value?.id){
      newValue = value.id;
    } else if(attributeField && value?.[attributeField]){
      newValue = value[attributeField];
    } else{
      newValue = value;
    }

    setJsonConfig((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  }

  const addCodigo = () => {
    let items = jsonConfig?.items || [];

    items.push({
      codeType: "",
      modelo: "",
      resultId: "",
      content: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      items: items
    }));
  };

  const handleChangeListValue = (event, index, name, objListName) => {
    if(!event?.target) return;

    const { value } = event.target;
    let objList = jsonConfig?.[objListName] || [];

    objList[index] = {
      ...objList[index],
      [name]: value,
    }

    setJsonConfig((prev) => ({
      ...prev,
      [objListName]: objList
    }));
  };

  const removeListItem = (event, index, objListName) => {
    let objItems = jsonConfig?.[objListName] || [];

    objItems.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      [objListName]: objItems
    }));
  };

  const handleChangeAutoCompleteListValue = (event, value, index, name, objListName, attributeField) => {
    if(!event?.target) return;
    
    let objList = jsonConfig?.[objListName] || [];

    let newValue;
    if(typeof value === 'string'){
      newValue = value;
    } else if(value?.id){
      newValue = value.id;
    } else if(attributeField && value?.[attributeField]){
      newValue = value[attributeField];
    } else{
      newValue = value;
    }

    objList[index] = {
      ...objList[index],
      [name]: newValue,
    }

    setJsonConfig((prev) => ({
        ...prev,
        [objListName]: objList
    }));
  };

  const handleClearAutoCompletePropValue = (index, name, objListName, value) => {

    let objList = jsonConfig?.[objListName] || [];
    objList[index] = {
      ...objList[index],
      [name]: value,
    }

    setJsonConfig((prev) => ({
      ...prev,
      [objListName]: objList
    }));

  }

  const { tabValue } = state;

  return (
    open && (
        <GenericModal
          title={language.configuration}
          handleClose={handleClose}
          size={state.maxWidth}
          bigHeight
          open={true}
          handleSubmit={handleSave}
          btnActionTitle={language.save}
          btnCancelTitle={language.cancel}
          overrideDialogActions={() =>
            OverrideModalActions({
              handleSubmit: handleSave,
              handleClose: handleClose,
            })
          }
        >
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={tabValue}
              indicatorColor="secondary"
              textColor="secondary"
              onChange={handleChangeTab}
            >
              <Tab label={language.properties} />
              <Tab label={language.configuration} hidden />
              <Tab label={language.permissions} hidden />
            </Tabs>
          </Box>

          <FormPadding>
            <TabPanel value={tabValue} index={0}>
              <Grid container spacing={3}>
                <TabProperties
                  businessObject={businessObject}
                  taskFields={FormComponents}
                  jsonConfig={jsonConfig}
                  
                  addCodigo={addCodigo}

                  handleChangeListValue={handleChangeListValue}
                  removeListItem={removeListItem}
                  handleChangeAutoCompleteListValue={handleChangeAutoCompleteListValue}
                  handleClearAutoCompletePropValue={handleClearAutoCompletePropValue}

                  handleChangeConfigFields={handleChangeConfigFields}
                  handleChangeAutoCompleteConfigFields={handleChangeAutoCompleteConfigFields}

                />
              </Grid>
            </TabPanel>
          </FormPadding>

        {hasConfigError && (
            <GenericSnackbar
              errorWithChildren={true}
                message={
                  <div>
                    {hasConfigError.map((err, index) => {
                        return <div
                          key={`errorMessage_${index}`}
                        >
                          {err}
                        </div>;
                      })
                    }
                  </div>
                }
                handleClose={() => setHasConfigError(false)}
                duration={4000}
            />
          )}
       </GenericModal>
    )
  );
}

export default ModelerGerarQrBarCode;
